import type { OptionProps } from '@amelio/ui-library';

import { CommonActions } from '@/constants/Actions';
import { ReviewType } from '@/constants/review/CycleInstance';

/** The row actions a read-only Manager Assessment keeps only as an upgrade offer. */
const LOCKED_ACTION_IDS: ReadonlySet<string> = new Set([CommonActions.EDIT, CommonActions.DELETE]);

/**
 * Whether a review on the Evaluations dashboard is a Manager Assessment the company can only read:
 * one created before it lost Performance PRO. It stays listed (nothing a company made disappears
 * on a downgrade), but it can no longer be edited or deleted.
 */
export const isReadOnlyManagerAssessment = (
    reviewType: string | undefined,
    isPro: boolean,
): boolean => !isPro && reviewType === ReviewType.MANAGER_EVALUATION;

/** Whether a row action of the Evaluations dashboard changes the review (see `lockReadOnlyActions`). */
export const isLockableEvaluationAction = (action: OptionProps): boolean =>
    LOCKED_ACTION_IDS.has(action.id ?? '');
